'use client'

import { Searchbar } from '@/components/common/Searchbar'

import styles from './Header.module.scss'
import { HeaderButtonClipboard } from './HeaderButtonClipboard/HeaderButtonClipboard'
import { HeaderButtonFilters } from './HeaderButtonFilters/HeaderButtonFilters'
import { HeaderButtonNav } from './HeaderButtonNav/HeaderButtonNav'
import { HeaderButtonUser } from './HeaderButtonUser/HeaderButtonUser'
import { HeaderLogo } from './HeaderLogo/HeaderLogo'
import { HeaderNav } from './HeaderNav/HeaderNav'

export const Header = () => (
  <>
    <header className={styles.container}>
      <HeaderButtonNav />
      <HeaderLogo />
      <HeaderNav />
      <HeaderButtonClipboard />
      <Searchbar />
      <HeaderButtonUser />
    </header>
    <HeaderButtonFilters />
  </>
)
